import { styled } from '@mui/material/styles'

const Spacer = styled('div')`
  height: ${({ count }: { count?: number }) => count ?? 1}rem;
`

export { Spacer }
